import { registerComponent } from "helpers";
import WYATTElement from "wyatt";

registerComponent(
  "store-distance",
  class StoreDistance extends WYATTElement {
    constructor() {
      super();
      this.distanceElement = this.querySelector("[data-distance]");
    }

    connectedCallback() {
      if (this.userLocation) {
        this.render();
      } else {
        this.subscribe(
          WYATT.PubSub.events.userLocationSet,
          this.render.bind(this),
        );
      }
    }

    get handle() {
      return this.config.handle;
    }

    get store() {
      return WYATT.shopify.stores.find(({ handle }) => handle === this.handle);
    }

    get userLocation() {
      return WYATT.Geolocation.location.coordinates;
    }

    get distance() {
      const meters = WYATT.Geolocation.getDistanceBetween(
        this.store.coordinates,
        this.userLocation,
      );
      const miles = meters * 0.000621371;
      return miles.toFixed(1);
    }

    render() {
      this.distanceElement.textContent = `${this.distance} mi`;
    }
  },
);
